import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface SupportLink {
  id: string;
  icon: string;
  label: string;
  description: string;
  href: string;
}

const SupportSection = () => {
  const supportLinks: SupportLink[] = [
    {
      id: 'help',
      icon: 'QuestionMarkCircleIcon',
      label: 'Need Help?',
      description: 'Visit our help center for FAQs and guides',
      href: '/landing-page'
    },
    {
      id: 'contact',
      icon: 'ChatBubbleLeftRightIcon',
      label: 'Contact Support',
      description: 'Our team is available 24/7 to assist you',
      href: '/landing-page'
    },
    {
      id: 'privacy',
      icon: 'DocumentTextIcon',
      label: 'Privacy Policy',
      description: 'Learn how we protect your information',
      href: '/landing-page'
    }
  ];

  return (
    <div className="bg-muted/50 border border-border rounded-xl p-8">
      <h2 className="text-xl font-heading font-semibold text-foreground mb-6 text-center">
        Need Assistance?
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {supportLinks.map((link) => (
          <Link
            key={link.id}
            href={link.href}
            className="flex flex-col items-center text-center p-4 bg-card border border-border rounded-lg transition-smooth hover:shadow-elevation-md hover:border-primary group"
          >
            <Icon 
              name={link.icon as any} 
              size={28} 
              className="text-primary mb-3 transition-smooth group-hover:scale-110"
            />
            <h3 className="font-medium text-foreground mb-1 group-hover:text-primary transition-smooth">
              {link.label}
            </h3>
            <p className="text-sm text-muted-foreground">
              {link.description}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SupportSection;